import React, { Component } from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import { Tooltip, Typography } from "@material-ui/core";
import { toast } from 'react-toastify';
import InfoIcon from '@material-ui/icons/Error';
import { getDetailFlow } from '../../store/action/RegisterTemplate/Flow'

class ButtonManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: "",
      limitButton: 2,
      buttonList: fromJS([]),
      buttonTemplate: fromJS({
        button_type: "",
        button_message: "",
        button_value: "",
        value_type: "",
      }),
      buttonTypes: fromJS([
        {
          "selected-type": "Mix Buttons",
          "selected-type-value": "mix_buttons",
        }
      ]),
      buttonTypesCarousel: fromJS([
        {
          "selected-type": "Button Card Carousel",
          "selected-type-value": "button_card_carousel",
        },
      ]),
      buttonValueTypes: fromJS([
        { value_type: "Static", value_type_value: "static" },
        { value_type: "Dynamic", value_type_value: "dynamic" },
      ]),
      subButtonCouponLtoTypes: fromJS([
        { 'button_type': 'Copy Code', 'button_type_value': 'copy_code' },
        { 'button_type': 'URL', 'button_type_value': 'URL' },
        { 'button_type': 'Phone Number', 'button_type_value': 'PHONE_NUMBER' },
        { 'button_type': 'Quick Reply', 'button_type_value': 'quick_reply' },
      ]),
      subButtonRegulerTypes: fromJS([
        { 'button_type': 'URL', 'button_type_value': 'URL' },
        { 'button_type': 'Phone Number', 'button_type_value': 'PHONE_NUMBER' },
        { 'button_type': 'Quick Reply', 'button_type_value': 'quick_reply' },
      ]),
      errors: fromJS({}),
      error: "",
      listScreenFlow: fromJS([])
    };
    this.handleAddButton = this.handleAddButton.bind(this);
    this.getDetailFlow = this.getDetailFlow.bind(this);
  }

  async getDetailFlow(flowId) {
    const response = await getDetailFlow(flowId);
    if(response.ok){
        let data = await response.json();
        let listScreen = [];
        data.data.screens.forEach(screen => {
          listScreen.push({
            id: screen,
            name: screen
          })
        });
        this.setState({listScreenFlow: fromJS(listScreen)})
    }
}

  handleChange(field, value, label, index) {
    const { templateType } = this.props;
    if (field === "selected-type") {
      this.setState(
        {
          selectedType: value,
          buttonList: fromJS([]),
        },
        function () {
          this.handleAddButton();
        }
      );
      
      this.setState({ buttonList: fromJS([]) }, this.passData);
    } else {
      var buttonListCopy = this.state.buttonList;
      var buttonCopy = buttonListCopy.get(index);
      if (field === "button_type") {
        if (value === "copy_code" && (templateType === "lto" || templateType === 'coupon')) {
          buttonCopy = buttonCopy.set('button_value', 'copy_code');
          buttonCopy = buttonCopy.set('button_message', 'Copy code');
          buttonListCopy = buttonListCopy.set(index, buttonCopy);
        } else {
          buttonCopy = buttonCopy.set('button_value', '');
          buttonCopy = buttonCopy.set('button_message', '');
          buttonListCopy = buttonListCopy.set(index, buttonCopy);
        }
      }

      let selectedType = this.state.selectedType;
      if (field === 'button_message' && (buttonCopy.get('button_type') === 'quick_reply' || selectedType === 'copy-code' || selectedType === 'one-tap' || selectedType === 'catalog' || selectedType === 'mpm' || selectedType === 'flow')) {
        buttonCopy = buttonCopy.set("button_value", value);
        buttonListCopy = buttonListCopy.set(index, buttonCopy);
      }

      if (field === 'value_type' && value !== 'dynamic') {
        const currentValue = buttonCopy.get('button_value')
        if (currentValue && currentValue.length && currentValue.includes('{{1}}')) {
          const newValue = currentValue.replace(/\{\{1\}\}/g, '')
          buttonCopy = buttonCopy.set('button_value', newValue);
          buttonListCopy = buttonListCopy.set(index, buttonCopy);
        }
      }

      if (field === "flow_id") {
        this.setState({listScreenFlow: fromJS([])})
        buttonCopy = buttonCopy.set('navigate_screen', '')
        buttonListCopy = buttonListCopy.set(index, buttonCopy)
        this.getDetailFlow(value);
    }

      buttonCopy = buttonCopy.set(field, value);
      buttonListCopy = buttonListCopy.set(index, buttonCopy);
      
      this.setState({ buttonList: buttonListCopy }, this.passData);
    }
  }

  handleAddParamButton = (index) => {
    let buttonListCopy = this.state.buttonList;
    let buttonCopy = buttonListCopy.get(index);
    let currentValue = buttonCopy.get('button_value')
    buttonCopy = buttonCopy.set('button_value', currentValue + '{{1}}')
    buttonListCopy = buttonListCopy.set(index, buttonCopy)
    this.setState({ buttonList: buttonListCopy }, this.passData);
  }

  passData() {
    var templateButtons = this.state.buttonList;

    this.props.onChange("template-buttons", templateButtons);
  }

  handleAddButton() {
    var { buttonTemplate, buttonList, selectedType } = this.state;
    if (selectedType === "copy-code") {
      let newButton = fromJS({
        button_type: "URL",
        otp_type: "COPY_CODE",
        button_message: "",
        button_value: "",
        value_type: "",
      });
      this.addButton(buttonList, newButton);
    } else if (selectedType === "one-tap") {
      let newButton = fromJS({
        button_type: "URL",
        otp_type: "ONE_TAP",
        button_message: "",
        button_value: "",
        autofill_text: "",
        package_name: "",
        signature_hash: "",
        value_type: "",
      });
      this.addButton(buttonList, newButton);
    } else if (selectedType === "catalog") {
      let newButton = fromJS({
        button_type: "CATALOG",
        button_message: "View catalog",
        button_value: "View catalog",
        value_type: "",
      });
      this.addButton(buttonList, newButton);
    } else if (selectedType === "mpm") {
      let newButton = fromJS({
        button_type: "MPM",
        button_message: "View items",
        button_value: "View items",
        value_type: "",
      });
      this.addButton(buttonList, newButton);
    } else if (selectedType === "flow") {
      let newButton = fromJS({
        button_type: "FLOW",
        button_message: "",
        button_value: "",
        flow_id: "",
        navigate_screen: "",
        flow_action: "navigate",
        value_type: "",
      });
      this.addButton(buttonList, newButton);
    } else if (selectedType === 'coupon_lto' && buttonList.size < 2) {
      this.addButton(buttonList, buttonTemplate);
    } else if (selectedType === 'button_card_carousel' && buttonList.size < 2) {
      this.addButton(buttonList, buttonTemplate);
    } else if (selectedType === 'mix_buttons' && buttonList.size < 10) {
      this.addButton(buttonList, buttonTemplate);
    }
  }

  addButton(buttonList, buttonTemplate) {
    this.setState(
      {
        buttonList: fromJS([...buttonList, buttonTemplate]),
      },
      this.passData
    );
  }

  handleRemoveButton(index) {
    var { buttonList } = this.state;
    if (buttonList.size > 0) {
      buttonList = buttonList.splice(index, 1);

      this.setState(
        {
          buttonList: buttonList,
        },
        this.passData
      );
    }
  }

  componentDidMount() {
    if (this.props.items.size > 0) {
      let buttonType = this.props.items.get(0).get("button_type") ? this.props.items.get(0).get("button_type").toLowerCase() : '';
      let typeText = '';
      if (this.props.categoryId === '1') {
        if (buttonType === 'url') {
          let otpType = this.props.items.get(0).get("otp_type") ? this.props.items.get(0).get("otp_type").toLowerCase() : null;
          if((otpType === 'copy_code')) {
            typeText = 'copy-code'; 
          } else if (otpType === 'one_tap') {
            typeText = 'one-tap'; 
          }
        }
      } else if (this.props.templateType === 'lto' || this.props.templateType === 'coupon') {
        typeText = 'coupon_lto'
      } else if (this.props.templateType === 'catalog') {
        typeText = 'catalog'
      } else if (this.props.templateType === 'mpm') {
        typeText = 'mpm'
      } else if (this.props.templateType === 'flow') {
        this.getDetailFlow(this.props.items.get(0).get("flow_id"));
        typeText = 'flow'
      } else if (this.props.templateType === 'carousel') {
        typeText = 'button_card_carousel'
      } else {
        typeText = 'mix_buttons'
      }
      this.setState({
        buttonList: this.props.items,
        selectedType: typeText,
      });
    }
    if (this.props.categoryId === '1') {
      this.setState({
        buttonTypes: fromJS([
          { "selected-type": "Copy Code", "selected-type-value": "copy-code" },
          { "selected-type": "One Tap", "selected-type-value": "one-tap" },
        ])
      });
    } else {
      if (this.props.templateType === 'carousel') {
        this.setState({
          buttonTypes: fromJS([
            {
              "selected-type": "Button Card Carousel",
              "selected-type-value": "button_card_carousel",
            },
          ])
        });
      } else if (this.props.templateType === 'lto' || this.props.templateType === 'coupon') {
        this.setState({
          buttonTypes: fromJS([
            {
              "selected-type": "Coupon / LTO",
              "selected-type-value": "coupon_lto",
            },
          ])
        });
      } else if (this.props.templateType === 'catalog') {
        this.setState({
          buttonTypes: fromJS([
            {
              "selected-type": "Button Catalog",
              "selected-type-value": "catalog",
            },
          ])
        });
      } else if (this.props.templateType === 'mpm') {
        this.setState({
          buttonTypes: fromJS([
            {
              "selected-type": "Button MPM",
              "selected-type-value": "mpm",
            },
          ])
        });
      } else if (this.props.templateType === 'flow') {
        this.setState({
          buttonTypes: fromJS([
            {
              "selected-type": "Button Flow",
              "selected-type-value": "flow",
            },
          ])
        });
      } else {
        this.setState({
          limitButton: 10,
          buttonTypes: fromJS([
            {
              "selected-type": "Mix Buttons",
              "selected-type-value": "mix_buttons",
            },
          ])
        });
      }
    }
    
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listFlow !== this.props.listFlow) {
      this.setState({listScreenFlow: fromJS([])})
      if (this.state.selectedType === 'flow' && this.state.buttonList.size > 0) {
        let buttonListCopy = this.state.buttonList;
        let buttonCopy = buttonListCopy.get(0);
        buttonCopy = buttonCopy.set('flow_id', '')
        buttonCopy = buttonCopy.set('navigate_screen', '')
        buttonListCopy = buttonListCopy.set(0, buttonCopy)
        this.setState({ buttonList: buttonListCopy }, this.passData);
      }
    }
    if (prevProps.categoryId !== this.props.categoryId || prevProps.templateType !== this.props.templateType) {
      let buttonTypesOption = fromJS([]);
      let buttonLimit = 2
      if (this.props.categoryId === '1') {
        buttonTypesOption = fromJS([
          { "selected-type": "Copy Code", "selected-type-value": "copy-code" },
          { "selected-type": "One Tap", "selected-type-value": "one-tap" },
        ]);
      } else {
        if (this.props.templateType === 'lto' || this.props.templateType === 'coupon') {
          buttonTypesOption = fromJS([
            {
              "selected-type": "Coupon / LTO",
              "selected-type-value": "coupon_lto",
            },
          ]); 
        } else if(this.props.templateType === 'carousel') {
          buttonTypesOption = fromJS([
            {
              "selected-type": "Button Card Carousel",
              "selected-type-value": "button_card_carousel",
            },
          ]);
        } else if (this.props.templateType === 'catalog') {
          buttonTypesOption = fromJS([
            {
              "selected-type": "Button Catalog",
              "selected-type-value": "catalog",
            },
          ]);
        } else if (this.props.templateType === 'mpm') {
          buttonTypesOption = fromJS([
            {
              "selected-type": "Button MPM",
              "selected-type-value": "mpm",
            },
          ]);
        } else if (this.props.templateType === 'flow') {
          buttonTypesOption = fromJS([
            {
              "selected-type": "Button Flow",
              "selected-type-value": "flow",
            },
          ]);;
        } else {
          buttonLimit = 10
          buttonTypesOption = fromJS([
            {
              "selected-type": "Mix Buttons",
              "selected-type-value": "mix_buttons",
            }
          ]);
        }
      }

      this.setState({
        selectedType: "",
        buttonTypes: buttonTypesOption,
        buttonList: fromJS([]),
        limitButton: buttonLimit
      }, this.passData);
    }
  }

  render() {
    const { buttonList, selectedType, buttonTypes, buttonTypesCarousel } = this.state;
    const { templateType, listFlow } = this.props;
    let selections = buttonTypes;
    if (templateType === "carousel") {
      selections = buttonTypesCarousel;
    }
    return (
      <div>
        <div className="row col-sm-12">
          <span className="col-sm-2">Buttons</span>
          <div className="col-sm-10 ">
            <ComboboxInput
              field="selected-type"
              value={selectedType}
              options={fromJS({
                source: selections,
                value: "selected-type-value",
                label: "selected-type",
              })}
              disabled={this.props.disabled}
              placeholder="Buttons Type"
              onChange={(field, value, label) =>
                this.handleChange(field, value, label)
              }
            />
          </div>
        </div>
        {(selectedType === "copy-code" || selectedType === "catalog" || selectedType === "mpm") &&
          buttonList.map((buttonValue, index) =>
            this.renderButton(buttonValue, index)
        )}
        {selectedType === "flow" &&
          buttonList.map((buttonValue, index) =>
            this.renderButtonFlow(buttonValue, index, listFlow)
        )}
        {selectedType === "one-tap" &&
          buttonList.map((buttonValue, index) =>
            this.renderOneTap(buttonValue, index)
        )}
        {(selectedType === "coupon_lto" || selectedType === "button_card_carousel" || selectedType === "mix_buttons") &&
          buttonList.map((buttonValue, index) =>
            this.renderGeneralButtonTypes(buttonValue, index)
        )}
      </div>
    );
  }

  renderButton(buttonValue, index) {
    const { errors } = this.state;

    return (
      <div key={index} className="quick-reply row no-margin-bottom">
        <div className="col-sm-10 pull-right">
          {(buttonValue.get("button_type") === 'CATALOG' || buttonValue.get("button_type") === 'MPM') ? (
            <div className="row">
              <div className="col-sm-9 pr-5">
                  <TextInputField
                      field={"button_message"}
                      value={buttonValue.get("button_message")}
                      disabled={true}
                      hasError={errors.has('button_message')}
                  />
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-9 pr-5">
                <TextInputField
                  field={"button_message"}
                  value={buttonValue.get("button_message")}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Button Message (max 25 characters)"
                  maxLength={25}
                  disabled={this.props.disabled}
                  hasError={errors.has("button_message")}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderButtonFlow(buttonValue, index, listFlow) {
    const { errors } = this.state;

    return (
      <div key={index} className="quick-reply row no-margin-bottom">
        <div className="col-sm-10 pull-right">
          <div className="row">
            <div className="col-sm-9 pr-5">
              <TextInputField
                field={"button_message"}
                value={buttonValue.get("button_message")}
                onChange={(field, value, label) =>
                  this.handleChange(field, value, label, index)
                }
                placeholder="Button Message (max 25 characters)"
                maxLength={25}
                disabled={this.props.disabled}
                hasError={errors.has("button_message")}
              />
            </div>
            <div className="col-sm-9 pr-5">
              <ComboboxInput
                field='flow_id'
                value={buttonValue.get('flow_id')}
                options={fromJS({
                    'source': listFlow,
                    'value': 'flow_id',
                    'label': 'flow_name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                placeholder="Select Flow Name"
                disabled={this.props.disabled}
                hasError={errors.has("flow_id")}
              />
            </div>
            <div className="col-sm-9 pr-5">
              <ComboboxInput
                field='navigate_screen'
                value={buttonValue.get('navigate_screen')}
                options={fromJS({
                    'source': this.state.listScreenFlow,
                    'value': 'id',
                    'label': 'name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label, index)}
                placeholder="Select Flow Navigate Screen"
                disabled={this.props.disabled}
                hasError={errors.has("navigate_screen")}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderOneTap(buttonValue, index) {
    const { errors } = this.state;

    return (
      <div key={index} className="quick-reply row no-margin-bottom">
        <div className="col-sm-10 pull-right">
          <div className="row">
            <div className="col-sm-9 pr-5">
              <TextInputField
                field={"button_message"}
                value={buttonValue.get("button_message")}
                onChange={(field, value, label) =>
                  this.handleChange(field, value, label, index)
                }
                placeholder="Button Message (max 25 characters)"
                maxLength={25}
                disabled={this.props.disabled}
                hasError={errors.has("button_message")}
              />
            </div>
            <div className="col-sm-1 pl-0 pt-3">
              <Tooltip title={
                    <React.Fragment>
                        <Typography variant="h6" color="inherit">Note that even if your template is using a one-tap autofill button, this value must still be supplied. If we are unable to validate your handshake the authentication template message will display a copy code button with this text instead.</Typography>
                    </React.Fragment>
                } >
                  <button><i className='small-icon' ><InfoIcon /></i></button>
              </Tooltip>
            </div>
            <div className="col-sm-9 pr-5">
              <TextInputField
                field={"autofill_text"}
                value={buttonValue.get("autofill_text")}
                onChange={(field, value, label) =>
                  this.handleChange(field, value, label, index)
                }
                placeholder="Autofill Text (max 25 characters)"
                maxLength={25}
                disabled={this.props.disabled}
                hasError={errors.has("autofill_text")}
              />
            </div>
            <div className="col-sm-9 pr-5">
              <TextInputField
                field={"package_name"}
                value={buttonValue.get("package_name")}
                onChange={(field, value, label) =>
                  this.handleChange(field, value, label, index)
                }
                placeholder="Package name"
                maxLength={100}
                disabled={this.props.disabled}
                hasError={errors.has("package_name")}
              />
            </div>
            <div className="col-sm-9 pr-5">
              <TextInputField
                field={"signature_hash"}
                value={buttonValue.get("signature_hash")}
                onChange={(field, value, label) =>
                  this.handleChange(field, value, label, index)
                }
                placeholder="Signature Hash"
                maxLength={50}
                disabled={this.props.disabled}
                hasError={errors.has("signature_hash")}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderGeneralButtonTypes(buttonValue, index) {
    const { errors, subButtonCouponLtoTypes, subButtonRegulerTypes, buttonList, buttonValueTypes, selectedType, limitButton } = this.state;
    let buttonType = buttonList.get(index).get('button_type') == null ? "" : buttonList.get(index).get('button_type');

    return (
      <div key={index} className="call-to-action row no-margin-bottom col-sm-12">
        <div className="col-sm-10 pull-right">
          <div className="row">
            <div className="col-sm-10 pr-5">
              <ComboboxInput
                field="button_type"
                value={buttonValue.get('button_type')}
                options={fromJS({
                  source: selectedType === "coupon_lto" ? subButtonCouponLtoTypes : subButtonRegulerTypes,
                  value: 'button_type_value',
                  label: 'button_type',
                })}
                disabled={this.props.disabled}
                placeholder="Button Sub-Type"
                onChange={(field, value, label) => {
                  let addable = true;
                  let countBtnUrl = 0;
                  buttonList.forEach(btn => {
                    if (value !== "quick_reply" && value !== "URL" && btn.get('button_type') === value) {
                      addable = false;
                    }
                    if (btn.get('button_type') === "URL") {
                      countBtnUrl++;
                    }
                  });
                  if (value === "URL" && countBtnUrl >= 2) {
                    addable = false;
                  }
                  if (addable) {
                    this.handleChange(field, value, label, index)
                  } else {
                    if (value === "URL") {
                      toast.error('The limit of URL button is 2 buttons', toast.POSITION.TOP_RIGHT);
                    } else {
                      toast.error('The limit of '+value+' button is 1 button', toast.POSITION.TOP_RIGHT);
                    }
                  }
                }
                }
              />
            </div>
            {!this.props.disabled && buttonList.size > 1 && (
              <div className="col-sm-2 pl-0">
                <button
                  onClick={() => this.handleRemoveButton(index)}
                  className="btn btn-danger"
                >
                  Remove Button
                </button>
              </div>
            )}
          </div>
          {buttonType.toLowerCase() === 'url' && (
            <div className="row">
              <div className="col-sm-10 pr-5">
                <TextInputField
                  field={"button_message"}
                  value={buttonValue.get("button_message")}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Button Message (max 25 characters)"
                  maxLength={25}
                  disabled={this.props.disabled}
                  hasError={errors.has("button_message")}
                />
              </div>
              <div className="col-sm-10 pr-5">
                <ComboboxInput
                  field="value_type"
                  value={buttonValue.get('value_type')}
                  options={fromJS({
                    source: buttonValueTypes,
                    value: 'value_type_value',
                    label: 'value_type',
                  })}
                  placeholder="URL Type"
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  hasError={errors.has('value_type')}
                />
              </div>
              <div className="col-sm-9 pr-5">
                <TextInputField
                  autoCapitalize="none"
                  field={"button_value"}
                  value={buttonValue.get("button_value")}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="URL Link"
                  disabled={this.props.disabled}
                  hasError={errors.has("button_value")}
                />
              </div>
              <div className="col-sm-1 p-0">
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    style={{marginLeft: -20}}
                    onClick={() => this.handleAddParamButton(index)}
                    disabled={
                      this.props.disabled ||
                      buttonList.get(index).get('value_type') != 'dynamic' ||
                      buttonList.get(index).get('button_value').includes('{{1}}')
                    }
                >
                    {"{{}}"}
                </button>    
              </div>
              {!this.props.disabled &&
                buttonList.size - 1 === index &&
                buttonList.size < limitButton && (
                  <div className="col-sm-2">
                    <button
                      onClick={this.handleAddButton}
                      className="btn btn-success"
                    >
                      Add Button
                    </button>
                  </div>
                )}
            </div>
          )}
          {buttonType.toLowerCase() === 'phone_number' && (
            <div className="row">
              <div className="col-sm-5 pr-5">
                <TextInputField
                  field={"button_message"}
                  value={buttonValue.get("button_message")}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Button Message (max 25 characters)"
                  maxLength={25}
                  disabled={this.props.disabled}
                  hasError={errors.has("button_message")}
                />
              </div>
              <div className="col-sm-5 pl-0 pr-5">
                <TextInputField
                  field={"button_value"}
                  value={buttonValue.get("button_value")}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label, index)
                  }
                  placeholder="Phone Number"
                  disabled={this.props.disabled}
                  hasError={errors.has("button_value")}
                />
              </div>
              {!this.props.disabled &&
                buttonList.size - 1 === index &&
                buttonList.size < limitButton && (
                  <div className="col-sm-2">
                    <button
                      onClick={this.handleAddButton}
                      className="btn btn-success"
                    >
                      Add Button
                    </button>
                  </div>
                )}
            </div>
            )}
          {buttonType.toLowerCase() === 'quick_reply' && (
            <div className="row">
              <div className="col-sm-9 pr-5">
                  <TextInputField
                    field={"button_message"}
                    value={buttonValue.get("button_message")}
                    onChange={(field, value, label) =>
                      this.handleChange(field, value, label, index)
                    }
                    placeholder="Button Message (max 25 characters)"
                    maxLength={25}
                    disabled={this.props.disabled}
                    hasError={errors.has("button_message")}
                  />
              </div>
              {!this.props.disabled &&
                buttonList.size - 1 === index &&
                buttonList.size < limitButton && (
                  <div className="col-sm-2">
                    <button
                      onClick={this.handleAddButton}
                      className="btn btn-success"
                    >
                      Add Button
                    </button>
                  </div>
                )}
            </div>
          )}
          {buttonType.toLowerCase() === 'copy_code' && (
          <div className="row">
              <div className="col-sm-9 pr-5">
                  <TextInputField
                      field={'button_message'}
                      value={buttonValue.get('button_message') || "Copy code"}
                      disabled={true}
                      hasError={errors.has('button_message')}
                  />
              </div>
              {!this.props.disabled &&
                buttonList.size - 1 === index &&
                buttonList.size < limitButton && (
                  <div className="col-sm-2">
                    <button
                      onClick={this.handleAddButton}
                      className="btn btn-success"
                    >
                      Add Button
                    </button>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default connect()(ButtonManager);
